import styled from "styled-components";

export const ContentSection = styled.div`
  width: inherit;
  max-width: inherit;
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
